module.exports = __webpack_public_path__ + "static/media/moving_truck.4dec6256.svg";